import usePage from "../../hooks/usePage";
import { useNavigate } from "react-router-dom"; // 引入 useNavigate
import "./loginAnimation.sass";
import videoSrc from "../../assets/images/loginAnimation/animation.mov";

export default function Home() {
  usePage({ headerShow: false });
  let navigate = useNavigate(); // 使用 useNavigate 鈎子來獲得 navigate 函數

  const handleVideoEnd = () => {
    navigate("/initialExplanation"); // 當視頻結束時執行跳轉
  };

  return (
    <div className="video-container">
      <video
        autoPlay="autoplay"
        muted
        className="video"
        onEnded={handleVideoEnd}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}
